
export function reorder<T>(list: T[], filterValues: (v: T) => boolean, startIndexInFilteredList: number, endIndexInFilteredList: number) {
  const result = Array.from(list);
  const filteredList = list.filter(filterValues);
  const startIndex = list.findIndex(x => x === filteredList[startIndexInFilteredList]);
  const endIndex = list.findIndex(x => x === filteredList[endIndexInFilteredList]);

  const [ removed ] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
}